module.exports = __webpack_public_path__ + "static/img/pic_zhutu1.c3bd8b2e.jpg";